import { TConsumerItem } from '../../../types/data';
import { TransactionStatusEnum } from '../../../types/enums';

export const convertTransactionItems = (items: Array<TConsumerItem>): Array<TConsumerItem> => {
    const newItems = structuredClone(items ?? []);
    if (Array.isArray(newItems)) {
        newItems
            .filter((i) => i?.date)
            .forEach((item) => {
                try {
                    item.date = new Date(item?.date ?? '');
                } catch {
                    // @ts-expect-error
                    item['date'] = null;
                }
            });
    }
    return newItems;
};

export const resolveArguments = (message = '', args: Array<string> | string | number) => {
    const regex = /\{\d}/g;
    const formattedMessage = message ?? '';
    if (Array.isArray(args)) {
        let resolveMessage = formattedMessage;
        const matchArray = formattedMessage.match(regex);
        if (matchArray) {
            args.forEach((argument, index) => {
                resolveMessage = resolveMessage.replaceAll(`{${index}}`, argument);
            });
            if (matchArray.length !== args.length) {
                resolveMessage = resolveMessage.replace(regex, '');
            }
        }
        return resolveMessage;
    } else if (args) {
        let newMessage;
        const matchArray = formattedMessage.match(regex);
        if (matchArray && matchArray[0]) {
            // @ts-expect-error
            const newMessForFirst = formattedMessage.replaceAll(`{0}`, args);
            if (matchArray.length > 1) {
                newMessage = newMessForFirst.replace(regex, '');
            } else {
                return newMessForFirst;
            }
            return newMessage;
        } else {
            return formattedMessage;
        }
    } else {
        return formattedMessage;
    }
};

export const mergeArrays = (
    oldArray: Array<TConsumerItem>,
    newArray: Array<TConsumerItem>,
): {
    isHasChanges: boolean;
    items: Array<TConsumerItem>;
} => {
    const newItemsMap = new Map(newArray.map((item) => [item.id, item]));

    const updatedArray = oldArray
        .filter((oldItem) => oldItem.status !== TransactionStatusEnum.AWAITING || newItemsMap.has(oldItem.id))
        .map((item) => newItemsMap.get(item.id) ?? item);

    const oldItemsIds = new Set(oldArray.map((item) => item.id));
    const addedItems = newArray.filter((newItem) => !oldItemsIds.has(newItem.id));

    const mergedArray = [...updatedArray, ...addedItems];

    return { isHasChanges: !isArrayEqual(oldArray, mergedArray), items: mergedArray };
};

const isArrayEqual = (oldArray: Array<TConsumerItem>, newArray: Array<TConsumerItem>): boolean => {
    if (oldArray?.length !== newArray?.length) {
        return false;
    }

    if (!oldArray || oldArray.length === 0) {
        return true;
    }

    const newItemsMap = new Map(newArray.map((item) => [item.id, item]));

    return oldArray.every((oldItem) => {
        const newItem = newItemsMap.get(oldItem.id);
        return newItem && oldItem.status === newItem.status;
    });
};
